import { ONLY_NUMBERS_REGEX, PHONE_REGEX } from './constants';

export const formatPhone = (phone: string) => {
	return phone?.replace(/\D/g, '');
};

export const maskPhone = (phone: string) => {
	const ddd = phone.slice(0, 2);
	const prefix = phone.slice(2, 7);
	const sufix = phone.slice(7, 11);
	return `(${ddd})${prefix}-${sufix}`;
};

export const unMaskPhone = (phone: string) => {
	return phone?.replace(ONLY_NUMBERS_REGEX, '');
};

export const isPhone = (phone: string) => {
	return !!new RegExp(PHONE_REGEX).exec(phone);
};
